import React from 'react';

import {message, Upload} from 'antd';
import {InboxOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {chatService} from "../../../../../services/chatService";
import {getErrorFromResponse} from "../../../../../utils/error.utils";
import {isDisabled} from "../../../../../utils/security.utils";
import {fileService} from "../../../../../services/fileService";

const {Dragger} = Upload;

export const ChatUploadData = ({fileUploadLimit, user, type}) => {

    let history = useHistory();

    const handleChange = (info) => {
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed. ${info.file.response}.`);
        }
    };

    const handleUpload = ({file, onError, onSuccess, onProgress}) => {

        if (type === 'file') {

            fileService.uploadFile(file).then((response) => {
                const data = response.data;
                history.push(`/view/${data.id}/preview`)
            }).catch(error => {
                onError(error, getErrorFromResponse(error));
            });

        } else {

            chatService.uploadFile(file).then((response) => {
                const data = response.data;
                // onSuccess(file);\
                history.push(`/chats/${data.id}`);
            }, error => {
                onError(error, getErrorFromResponse(error));
            }).finally(() => {
            });

        }

    }

    const beforeUpload = (file) => {

        const extension = file.name.split('.').pop();

        const isValid = file.type === 'text/csv' || extension === 'csv' || extension === 'xlsx' ||
            extension === 'parquet' || extension === 'tsv' || extension === 'json';

        if (!isValid) {
            message.error('You can only upload csv, excel, parquet, tsv or json files!');
            return false;
        }

        // check the file size - you can specify the file size you'd like here:
        const biggerThenLimit = (file.size / 1024 / 1024) > fileUploadLimit;
        if (biggerThenLimit) {
            message.error(`Based on your selected plan, the uploaded file must be smaller than the allowed limit ${fileUploadLimit}MB!`);
            return false;
        }

        return true;
    }

    return <div><Dragger name="file" multiple={false}
                         accept=".csv, .xlsx, .parquet, .tsv, .json"
                         maxCount={1}
                         onChange={handleChange}
                         beforeUpload={beforeUpload}
                         showUploadList={false}
                         customRequest={handleUpload}
                         disabled={isDisabled(user)}
    >
        <p className="ant-upload-drag-icon">
            <InboxOutlined/>
        </p>
        <p className="ant-upload-text">Click or drag csv, excel, parquet, tsv or json file to this area to upload</p>
        <p className="ant-upload-hint">
            Based on your selected plan, the uploaded file must be smaller than the allowed limit {fileUploadLimit}MB!
        </p>
    </Dragger></div>
}